/*
 * vd-intl.js : mecanique internationale du theme Vanille Desire.
 *
 * Point de chargement UNIQUE : fin de sections/vd-yc-product.liquid,
 * via {{ 'vd-intl.js' | asset_url | script_tag }}. Ne pas le charger ailleurs.
 *
 * Role : faire respecter le minimum d'achat export pose par le Liquid de la
 * fiche produit (metafield produit vd.min_qty_intl, attribut data-vd-min-qty
 * sur le champ quantite). Deux garde-fous :
 *   1. clamp a la saisie manuelle (le champ ne descend jamais sous le minimum ;
 *      les boutons +/- de vd-yc.js respectent deja l'attribut min du champ) ;
 *   2. verification a la soumission du formulaire d'ajout panier, en phase
 *      CAPTURE pour passer avant le handler AJAX de vd-yc.js (on ne touche
 *      pas a vd-yc.js : un autre chantier y travaille).
 *
 * Sans minimum (data-vd-min-qty absent ou egal a 1), ce script ne fait rien :
 * comportement strictement identique a avant.
 */
(function () {
  'use strict';

  var getMin = function (input) {
    var raw = input && input.getAttribute('data-vd-min-qty');
    var min = parseInt(raw || '1', 10);
    if (isNaN(min) || min < 1) return 1;
    return min;
  };

  /* Met brievement le message minimum en evidence (il est deja rendu par le
     Liquid, traduit, avec le bon pays et le bon nombre). */
  var flashNote = function (form) {
    var scope = form.closest('.vd-pdp') || document;
    var note = scope.querySelector('[data-vd-min-note]');
    if (!note) return;
    note.style.opacity = '1';
    note.style.fontWeight = '600';
    window.setTimeout(function () {
      note.style.opacity = '';
      note.style.fontWeight = '';
    }, 2500);
  };

  /* Garde-fou 1 : clamp a la saisie manuelle. */
  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('input[name="quantity"][data-vd-min-qty]')) return;
      var min = getMin(input);
      if (min <= 1) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < min) input.value = min;
    },
    true
  );

  /* Garde-fou 2 : verification a l'ajout panier. Phase capture : ce handler
     s'execute avant celui de vd-yc.js (submit AJAX sur /cart/add) et le
     neutralise si la quantite est sous le minimum. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-vd-pdp-form]')) return;
      var input = form.querySelector('input[name="quantity"][data-vd-min-qty]');
      if (!input) return;
      var min = getMin(input);
      if (min <= 1) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < min) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.value = min;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        flashNote(form);
      }
    },
    true
  );
})();
